import { render, staticRenderFns } from "./baseConfig.vue?vue&type=template&id=c215d7ee&scoped=true"
import script from "./baseConfig.vue?vue&type=script&lang=js"
export * from "./baseConfig.vue?vue&type=script&lang=js"
import style0 from "./baseConfig.vue?vue&type=style&index=0&id=c215d7ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c215d7ee",
  null
  
)

export default component.exports